<template>
    <div class="notice">
        <ul class="notice_left clearfix">
            <template v-for="(item, index) in msgTypeData">
                <li :class="{ fl: 1, clickLi: activeMsgTypeIndex == index }" @click="clickMenus(item.value, index)" :key="index">{{ item.label }}</li>
            </template>
        </ul>
        <div class="notice_right tableParent">
            <div class="btnGroups clearfix" v-if="0">
                <el-button class="fr" type="primary" size="small">全部已读</el-button>
            </div>
            <el-table class="tableHeightAdaptive" :data="tableData" max-height="480px" stripe>
                <el-table-column prop="companyName" label="所属公司">
                    <template slot-scope="scope">
                        <overflow-txt :txt="scope.row.companyName"></overflow-txt>
                    </template>
                </el-table-column>
                <el-table-column prop="plateNo" label="车牌号"> </el-table-column>
                <el-table-column prop="deviceNumber" label="设备号"> </el-table-column>
                <el-table-column prop="vin" label="车架号"> </el-table-column>
                <el-table-column prop="startTime" label="告警时间"> </el-table-column>
            </el-table>
            <el-pagination
                v-if="0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="paginationData.pageNo"
                :page-size="paginationData.pageSize"
                :total="paginationData.total"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                style="margin-top: 10px"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            fullscreenLoading: null,
            liMenus: ['驾驶行为告警', '电子围栏', '告警类型'],
            userMessageReminderAlarmData: [],
            tableData: [],
            msgTypeData: [
                { label: '镜头遮挡', value: 'lensOcclusion', key: 0 },
                { label: '疲劳驾驶', value: 'fatigueDriving', key: 1 },
                { label: '前向碰撞', value: 'forwardCollision', key: 2 }
            ],
            activeMsgTypeIndex: 0,
            paginationData: {
                pageNo: 1,
                pageSize: 10,
                total: 34
            }
        };
    },
    computed: {
        productTypeData() {
            let typeData = this.$store.state.common.productTypeData;
            if (typeData && typeData.length) {
                let expandItem = typeData.find((item) => item.expandInfo);
                if (this.navForm.condition.deviceType == null) {
                    let defaultType = expandItem ? expandItem.metaData : typeData[0].metaData;
                    this.navForm.condition.deviceType = defaultType;
                    if (this.downloadForm) this.downloadForm.deviceType = defaultType;
                }
            }
            return typeData;
        },
        cascCaderOptions() {
            return this.$store.state.common.companyTreeData;
        }
    },
    mounted() {
        this.getUserMessageReminderAlarm();
    },
    methods: {
        getUserMessageReminderAlarm() {
            this.$request({
                method: 'post',
                url: '/ubi/api/advanceAlarm/userMessageReminderAlarm',
                data: {}
            }).then((res) => {
                if (res.code == 200) {
                    this.userMessageReminderAlarmData = res.data;
                    if (this.$route.query && this.$route.query.noticeType.length > 0) {
                        let tmpNoticeType = Number(this.$route.query.noticeType);
                        const targetItem = this.msgTypeData.find((item) => item.key === tmpNoticeType);
                        this.clickMenus(targetItem.value, tmpNoticeType);
                    }
                } else {
                    console.log('热力图获取失败');
                }
            });
        },
        clickMenus(msgType, msgTypeIndex) {
            this.tableData = this.userMessageReminderAlarmData[msgType];
            this.activeMsgTypeIndex = msgTypeIndex;
        },
        handleSizeChange() {},
        handleCurrentChange() {}
    },
    watch: {
        '$route.query.noticeType'(newType, oldType) {
            if (newType !== oldType) {
                this.activeMsgTypeIndex = newType;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.notice {
    display: flex;
    width: 100%;
    border-radius: 8px;
    padding: 10px;

    .notice_left {
        width: 200px; /* 固定宽度 */
        min-width: 130px;
        background: #fff;
        color: white;
        padding: 10px;
        height: 130px;
        border-radius: 4px;
        li {
            display: inline-block;
            width: 100%;
            line-height: 32px;
            // border-bottom: 1px solid #e9e9e9;
            font-size: 17px;
            cursor: pointer;
            color: #333;
            padding: 0 10px;
            border-radius: 3px;
            margin-bottom: 5px;
        }
        li:last-child {
            border: 0;
            margin-bottom: 0;
        }
        li:hover {
            background: #d4eaff;
            color: #333;
        }
        .clickLi {
            background: #409eff !important;
            color: #fff !important;
        }
    }
    .notice_right {
        flex: 1; /* 自动填充剩余空间 */
        background-color: #fff;
        color: white;
        padding: 10px;
        border-radius: 4px;
        margin-left: 20px; /* 添加间距 */
        height: calc(100vh - 100px);
        .btnGroups {
            margin-bottom: 10px;
        }
    }
}
</style>
